<template>
  <div class="no-print">
    <HeaderContainer location="../index.html"></HeaderContainer>
  </div>
  <div class="no-print" style="width: 99%;margin: 0 auto;padding-top: 20px">
    <lay-button type="normal" prefix-icon="layui-icon-return" style="float: left" size="sm" @click="backToMainPage">返回首页</lay-button>
    <lay-row space="10">
      <lay-col md="6" >
        <lay-card >
          <template v-slot:title>
            <lay-row >
              <lay-col md="24" style="text-align: center"><span >检测合格标签设计</span></lay-col>
            </lay-row>
          </template>
          <lay-row space="3">
            <lay-col md="24">
              <lay-line>尺寸规格</lay-line>
            </lay-col>
            <lay-col md="24">
              <lay-radio v-model="spec" name="spec_type" :value="0" label="50*30 {30/A4}"></lay-radio>
              <lay-radio v-model="spec" name="spec_type" :value="1" label="84*54 {9/A4}"></lay-radio>
            </lay-col>
            <lay-col md="24">
              <lay-input v-model="cert.no" placeholder="请输入设备编号">
                <template #prepend>设备编号:</template>
              </lay-input>
            </lay-col>
            <lay-col md="24">
              <lay-input v-model="cert.company" placeholder="请输入检查单位">
                <template #prepend>检查单位:</template>
              </lay-input>
            </lay-col>
            <lay-col md="24">
              <lay-col md="24">
                <lay-line>有 效 期</lay-line>
              </lay-col>
              <lay-col md="24">
                <lay-radio v-model="cert.expiration_date_type" name="expiration_date_type" :value="0" label="3个月"></lay-radio>
                <lay-radio v-model="cert.expiration_date_type" name="expiration_date_type" :value="1" label="半年"></lay-radio>
                <lay-radio v-model="cert.expiration_date_type" name="expiration_date_type" :value="2" label="自定义"></lay-radio>
              </lay-col>
              <lay-col md="24" v-if="cert.expiration_date_type == 2">
                <lay-input v-model="cert.expiration_date" placeholder="请输入有效期">
                  <template #prepend>有效期:</template>
                </lay-input>
              </lay-col>
            </lay-col>
            <lay-col md="24">
              <lay-line></lay-line>
            </lay-col>
            <lay-col md="24">
              <lay-input v-model="cert.person" placeholder="请输入检测人">
                <template #prepend>检测人:</template>
              </lay-input>
            </lay-col>

            <lay-col md="24">
              <lay-line>检测日期</lay-line>
              <lay-date-picker style="margin: 0 auto;width: 100%"  v-model="cert.check_date"    type="date"   placeholder="请选择检测日期"></lay-date-picker>
            </lay-col>
            <lay-col md="24">
              <div style="height: 10px"></div>
            </lay-col>
            <lay-col md="24">
              <lay-input v-model="cert.count">
                <template #prepend>打印数量:</template>
              </lay-input>
            </lay-col>
            <lay-col md="24">
              <lay-button type="primary" fluid  @click="addTag">添加</lay-button>
            </lay-col>


          </lay-row>

        </lay-card>
      </lay-col>
      <lay-col md="18" >
        <lay-panel style="height: 700px">
          <lay-scroll height="695px" style="" thumbColor="#1e9fff">
            <template v-if="!emptyAddTag">
              <lay-empty v-if="certs.length == 0" style="margin-top: 270px" description="暂无打印数据">

              </lay-empty>
              <lay-row space="10" v-else>
                <lay-col md="6" v-for="(item, n) in certs" v-bind:key="n">
                  <lay-panel style="text-align: left">
                    设备编号：{{item.no}} <br/>
                    检测单位：{{item.company}}<br/>
                    有效期：{{item.expiration_date_type == 0 ? '三个月' : item.expiration_date_type == 1 ? '半年' : item.expiration_date}}<br/>
                    检测人：{{item.person}}<br/>
                    检测日期：{{!item.check_date ? "" : item.check_date}}<br/>
                    打印数量：{{item.count}}<br/>
                    <p style="height: 10px"></p>
                    <lay-button type="danger" fluid  size="sm" @click="delItems(n)">删除</lay-button>
                  </lay-panel>
                </lay-col>
              </lay-row>
            </template>
          </lay-scroll>
        </lay-panel>
      </lay-col>
      <lay-col md="24">
        <lay-button type="normal" fluid  @click="print">打印</lay-button>
      </lay-col>
    </lay-row>
  </div>
  <div class="print" v-if="toPrint" >
    <div v-if="spec == 0">
      <div class="print-area" style="padding-top: 50px;"  v-for="n in (totalCount % 30 == 0 ? totalCount / 30 : parseInt(totalCount / 30 + '') + 1)" v-bind:key="n" >
        <TagSpec5030 :cert="certItems[(n - 1) * 30 + i - 1]" class="tag-5030" v-for="i in (n == (parseInt(totalCount / 30 + '') + 1) ? totalCount % 30 : 30)" v-bind:key="i"></TagSpec5030>
        <template v-if="n * 30 > totalCount">
          <TagSpec5030 :cert="cert" class="tag-5030" style="visibility: hidden" v-for="i in (30 - totalCount % 30)" v-bind:key="i"></TagSpec5030>
        </template>
      </div>
    </div>
    <div v-if="spec == 1">
      <div class="print-area" style="padding-top: 60px;"  v-for="n in (totalCount % 9 == 0 ? totalCount / 9 : parseInt(totalCount / 9 + '') + 1)" v-bind:key="n" >
        <TagSpec8454 :cert="certItems[(n - 1) * 9 + i - 1]" class="tag-8454" v-for="i in (n == (parseInt(totalCount / 9 + '') + 1) ? totalCount % 9 : 9)" v-bind:key="i"></TagSpec8454>
        <template v-if="n * 9 > totalCount">
          <TagSpec8454 :cert="cert" class="tag-8454" style="visibility: hidden" v-for="i in (9 - totalCount % 9)" v-bind:key="i"></TagSpec8454>
        </template>
      </div>
    </div>
  </div>
</template>
<script setup>
import {computed, nextTick, reactive, ref, unref} from "vue";

import {layer} from "@layui/layui-vue";
import TagSpec8454 from "@/components/Tag/TagSpec8454";
import TagSpec5030 from "@/components/Tag/TagSpec5030";
import HeaderContainer from "@/components/utils/HeaderContainer";
const spec = ref(0);
let cert = reactive({
  spec:0,
  no: "",
  company: "",
  expiration_date_type: 0,
  expiration_date: "",
  person: "",
  checked: false,
  check_date: ref(null),
  count:1,
})

const certs = reactive([]);

const backToMainPage = () => {
  window.location.href = "../index.html"
}

const  certItems = computed(() => {
  let items = [];
  for (let item of certs){
    for (let i = 0 ; i < parseInt(item.count) ; i++){
      items.push(item);
    }
  }
  return items;
})

const emptyAddTag = ref(false);
const addTag = () => {

  if (cert.count == null || isNaN(parseInt(cert.count))|| cert.count <= 0) {
    layer.msg("请输入有效的打印数量", { icon : 2, time: 2000})
    return;
  }
  if (cert.company != null && cert.company.length > 17) {
    layer.msg("公司名称字数超出限制", { icon : 2, time: 2000})
    return;
  }
  emptyAddTag.value = true;
  certs.push({
    no: cert.no,
    company: cert.company,
    expiration_date_type: cert.expiration_date_type,
    expiration_date: cert.expiration_date,
    person: cert.person,
    checked: false,
    check_date: unref(cert.check_date),
    count:cert.count,
  })
  nextTick(() => {
    emptyAddTag.value = false;
    cert.count = 1;
  })

}

const totalCount = computed(() => {
  let total = 0;
  for (let item of certs){
    total += parseInt(item.count);
  }
  return total;
})



const toPrint = ref(false);




const delItems = (index) => {
  certs.splice(index, 1);
}

const print = () => {
  setTimeout(() => {
    toPrint.value = true;
  }, 500)

  setTimeout(() => {
    window.top.print();
    toPrint.value = false;
  }, 1000)
}

</script>

<style scoped>
.print-area{
  height: 20.9cm;
  width: 29.7cm;
  box-sizing: border-box;
}
.tag-5030{
  box-sizing: border-box;
  border: 5px solid black;
  border-radius: 2px;
  margin:1px 1px 0px;
}
.tag-8454{
  box-sizing: border-box;
  border: 12px solid black;
  border-radius: 5px;
  margin:3px 5px 0px;
}
</style>